import { type MaybeRefOrGetter, toValue } from 'vue';
import { useTitle } from '@vueuse/core';
import { useI18n } from 'vue-i18n';

/** `<page> · OhMyBible` as the document title, following the active locale. */
export const usePageTitle = (page: MaybeRefOrGetter<string>) => {
  const { t } = useI18n();

  return useTitle(() => t('app.documentTitle', { page: toValue(page) }));
};
